// Recovered compiled webpack factory 17237. Edit this function expression; run npm run build.
(e, s, a) => {
  a.d(s, { y: () => n });
  var d = a(95155);
  function n(e) {
    let { className: s = "h-6 w-6 animate-spin text-zinc-400 dark:text-zinc-600" } = e;
    return (0, d.jsx)("svg", {
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2.5",
      strokeLinecap: "round",
      className: s,
      "aria-hidden": "true",
      children: (0, d.jsx)("path", { d: "M21 12a9 9 0 1 1-6.219-8.56" }),
    });
  }
}
